module.exports = __webpack_public_path__ + "img/179960.89037b04.png";